<template>
    <ul class="select-colors" v-if="offers">
        <Swiper
            class="swiper offers-slider"
            :spaceBetween="swiperOptionTop.spaceBetween"
            :slides-per-view="swiperOptionTop.slidesPerView"
            :breakpoints="swiperOptionTop.breakpoints"
            ref="offersSlider"
        >
            <SwiperSlide
                class="swiper-slide"
                v-for="(offer, index) in offers"
                :key="offer.id"
            >
                <div class="slide-inner">
                    <input
                        type="radio"
                        class="filter-offer__checkbox"
                        :id="'offer-' + offer.id"
                        name="offer_id"
                        :value="offer.id"
                        v-model="offerSelect"
                    />
                    <label
                        :for="'offer-' + offer.id"
                        class="filter-offer__label"
                        :title="offer.name"
                    >
                        <template v-if="offer.preview_image">
                            <div v-if="offer.old_price_value > 0" class="onsale offer-product">%</div>
                            <picture>
                                <source media="(min-width:769px)" :srcset="offer.all_images[0]['w800']" type="image/jpeg" />
                                <source media="(max-width:768px)" :srcset="offer.all_images[0]['w500']" type="image/jpeg" />
                                <img
                                    class="product-card__img js-lazy-load"
                                    :srcset="offer.all_images[0]['w800']"
                                    :alt="offer.name"
                                    itemprop="image"
                                />
                            </picture>
                        </template>
                        <template v-else>
                            <img src="/assets/images/no-image.png" alt="offer" />
                        </template>
                    </label>
                </div>
            </SwiperSlide>
        </Swiper>
    </ul>
</template>

<script setup>
import { computed, ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'

// --- Props
const props = defineProps({
    startingOffer: { type: Number, required: true }
})

// --- Store getters
import { useStore } from 'vuex'
const store = useStore()
const offers = computed(() => store.getters.offers)

const offerSelect = computed({
    get() {
        return props.startingOffer
    },
    set(value) {
        store.commit('setOfferSelect', value)
    }
})

// --- Swiper options
const swiperOptionTop = {
    spaceBetween: 30,
    slidesPerView: 5,
    breakpoints: {
        320: {
            slidesPerView: 2,
            spaceBetween: 15,
        },
        420: {
            slidesPerView: 3,
            spaceBetween: 15,
        },
        510: {
            slidesPerView: 4,
        },
        768: {
            slidesPerView: 5,
            spaceBetween: 15,
        },
        992: {
            slidesPerView: 3,
            spaceBetween: 5,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 5,
        },
        1400: {
            slidesPerView: 5
        }
    }
}

// --- ref for Swiper instance
const offersSlider = ref(null)
</script>

<style scoped>
.swiper-slide-active .product-slide__img {
    border-radius: 4px;
}
</style>
